import React from 'react'

export default function Footer() {
    return (
        <footer className="bg-light text-center fixed-bottom py-2">
            <p className="m-0">Copyright &copy; MyToDosList.com</p>
        </footer>
    )
}
